import { createFileRoute } from '@tanstack/react-router';

import { AutodocViewer } from '@/components/Autodocs/AutodocViewer';
import { DocsSidebar } from '@/components/CodebaseView/DocsSidebar';
import { LeftSidebarPortal } from '@/components/portals/LeftSidebarPortal';
import { TocProvider, useToc } from '@/contexts/TocContext';

export const Route = createFileRoute('/$organizationName/pdf/$pdfVersionNodeId/autodocs/$autodocId')({
  component: ProvidedAutodocsDetailPage,
});

function ProvidedAutodocsDetailPage() {
  const { autodocId, pdfVersionNodeId } = Route.useParams();

  return (
    // We need to change the key to the autodocId to force a reset of the toc when the autodocId changes.
    <TocProvider key={autodocId}>
      <div className="mx-auto flex w-full flex-col gap-y-6 pt-4 pb-4">
        <AutodocsDetailPage autodocId={autodocId} versionNodeId={pdfVersionNodeId} />
      </div>
    </TocProvider>
  );
}

interface AutodocsDetailPageProps {
  autodocId: string;
  versionNodeId: string;
}

function AutodocsDetailPage({ autodocId, versionNodeId }: AutodocsDetailPageProps) {
  const { organizationName, pdfVersionNodeId } = Route.useParams();
  const { versionId } = Route.useSearch();
  const { editor, handleTabClick, tocItems } = useToc();

  return (
    <>
      <LeftSidebarPortal.Mount>
        <DocsSidebar
          backTo="/$organizationName/pdf/$pdfVersionNodeId/autodocs"
          backParams={{
            organizationName,
            pdfVersionNodeId,
          }}
          backSearch={versionId ? { versionId } : undefined}
          tocItems={tocItems}
          onTocClick={handleTabClick}
          editor={editor}
          showExpandCollapseButton={false}
        />
      </LeftSidebarPortal.Mount>
      <AutodocViewer autodocId={autodocId} versionNodeId={versionNodeId} />
    </>
  );
}
